export default {
  fieldNames: {
    shortText: 'Texto Breve',
    extendedDescription: 'Descripción extendida',
    colloquial1: 'Colloquial 1',
    colloquial2: 'Colloquial 2',
    colloquial3: 'Colloquial 3',
    colloquial4: 'Colloquial 4',
    colloquial5: 'Colloquial 5',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/cataloger/createNewMaterials/Stages/description.js